"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    argTypes: ()=>argTypes
});
const external_Carousel_variants_cjs_namespaceObject = require("./Carousel.variants.cjs");
const argTypes = {
    type: {
        control: {
            type: 'select'
        },
        options: external_Carousel_variants_cjs_namespaceObject.CarouselTypeOptions,
        description: '**Required** - Type of carousel (image or content)'
    },
    carouselId: {
        control: {
            type: 'text'
        },
        description: 'Unique identifier for carousel (auto generated if not provided)'
    },
    ariaLabel: {
        control: {
            type: 'text'
        },
        description: 'Aria label for carousel'
    },
    slides: {
        control: {
            type: 'object'
        },
        description: '**Required** - Array of slides - can be ImageSlide[] for image carousels or ContentSlide[] that takes in a list of custom ReactNodes for content carousels'
    },
    slideWidth: {
        control: {
            type: 'select'
        },
        options: external_Carousel_variants_cjs_namespaceObject.CarouselSlideWidthOptions,
        description: '**Important** - Width behavior for slides: image (default for image carousels), min (for content carousels with minimum width), auto (for content carousels with natural content width: e.g. filter chips; default for content carousels), same (for content carousels with equal calculated width)'
    },
    numSlides: {
        control: {
            type: 'select'
        },
        options: external_Carousel_variants_cjs_namespaceObject.CarouselNumSlidesOptions,
        description: '**Content carousels only with slideWidth="same"** - Number of slides visible at each container query breakpoint (default: one-two-three)'
    },
    minSlideWidth: {
        control: {
            type: 'text'
        },
        description: '**Content carousels only with slideWidth="min"** - Minimum width for slides when slideWidth is "min" (default: 256px)'
    },
    pagination: {
        control: {
            type: 'select'
        },
        options: external_Carousel_variants_cjs_namespaceObject.CarouselPaginationOptions,
        description: 'Type of pagination to display - numbers (displays navigation arrows & slide index), dots, or none'
    },
    isLightBoxSupported: {
        control: {
            type: 'boolean'
        },
        description: '**Image carousels only** - Whether to show lightbox button'
    },
    autoplay: {
        control: {
            type: 'select'
        },
        options: external_Carousel_variants_cjs_namespaceObject.CarouselAutoplayOptions,
        description: '**Image carousels only** - Autoplay behavior'
    },
    autoplayDelay: {
        control: {
            type: 'number'
        },
        description: '**Image carousels only** - Delay between autoplay transitions (ms); default: 5000'
    },
    syncWithGlobalAutoplay: {
        control: {
            type: 'boolean'
        },
        description: '**Image carousels only** - Sync autoplay state with global autoplay context'
    },
    rounded: {
        control: {
            type: 'select'
        },
        options: external_Carousel_variants_cjs_namespaceObject.CarouselRoundedOptions,
        description: 'Border radius for carousel'
    },
    dragFree: {
        control: {
            type: 'boolean'
        },
        description: '**Content carousels only** - Enable free dragging without snapping to slides'
    },
    slidesToScroll: {
        control: {
            type: 'number'
        },
        description: '**Content carousels only** - Number of slides to scroll at once'
    },
    loop: {
        control: {
            type: 'boolean'
        },
        description: '**Image carousels only** - Enable infinite looping (default: true for image carousels, always false for content carousels)'
    },
    bleed: {
        control: {
            type: 'select'
        },
        options: external_Carousel_variants_cjs_namespaceObject.CarouselBleedOptions,
        description: '**Content carousels only** - Bleed behavior (default: defaultBleed)'
    },
    bleedSpacing: {
        control: {
            type: 'select'
        },
        options: external_Carousel_variants_cjs_namespaceObject.CarouselBleedSpacingOptions,
        description: '**Content carousels only** - Bleed spacing (default: 4) only applicable when bleed is customBleed'
    },
    fullBleedPadding: {
        control: {
            type: 'select'
        },
        options: external_Carousel_variants_cjs_namespaceObject.CarouselFullBleedPaddingOptions,
        description: '**Content carousels only** - Full bleed padding (default: 2) only applicable when bleed is fullBleed'
    }
};
exports.argTypes = __webpack_exports__.argTypes;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "argTypes"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
